import { render, staticRenderFns } from "./InitialDocumentsAppApplyLeavePg.vue?vue&type=template&id=e2e82fc0&scoped=true"
import script from "./InitialDocumentsAppApplyLeavePg.vue?vue&type=script&lang=ts"
export * from "./InitialDocumentsAppApplyLeavePg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e82fc0",
  null
  
)

export default component.exports